import { useParams } from '@tanstack/react-router';
import { Button } from 'cpool-components/input/Button';
import { ButtonVariant } from 'cpool-components/input/Button/types';
import { AGGREGATE_NAMES } from 'cpool-constants';
import { useTranslation } from 'react-i18next';
import { LuRefreshCw } from 'react-icons/lu';

import { useAclPermissions } from '~/features/leadDetails/hooks/useAclPermissions';
import { cn } from '~/utils/cnTailwind';

type Props = {
    isPending: boolean;
    onClick: () => void;
};

export const EuropaceProcessEventsRequestButton: React.FC<Props> = ({ isPending, onClick }) => {
    const { t } = useTranslation();
    const params = useParams({ strict: false });
    const leadId = params?.leadId;
    const { permissions } = useAclPermissions({ loanRequestId: leadId });
    const isDisabled = !permissions.commands[AGGREGATE_NAMES.LOAN_REQUEST].requestEuropaceProcessEvents;

    return (
        <Button
            variant={ButtonVariant.SECONDARY}
            disabled={isPending || isDisabled}
            iconLeft={<LuRefreshCw className={cn('h-4 w-4', isPending && 'animate-spin')} />}
            onClick={() => onClick()}
        >
            {t('SIDE_INFO.EXTERNAL_SERVICES.EUROPACE.PROCESS_EVENTS.REQUEST_REFRESH')}
        </Button>
    );
};
